import React from "react";
import { BookOpenIcon, GiftIcon, GlobeIcon } from "lucide-react";
import { images } from "../../data/content";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
import { ScarcityBar } from "../ScarcityBar";
const stack = [{
  icon: BookOpenIcon,
  label: "Safe Spine Method™ — 6 Premium Volumes",
  value: "$97"
}, {
  icon: GiftIcon,
  label: "5 Professional Bonuses",
  value: "$147"
}];
const perks = ["One-time payment", "Lifetime access", "No monthly fees", "Instant digital access"];
export function Offer() {
  return <section id="offer" className="bg-navy-deep py-16 text-white sm:py-20" aria-labelledby="offer-title" data-id="element-194" data-mp="3f271ix0wp246">
      <div className="mx-auto max-w-2xl px-4 sm:px-5" data-id="element-195" data-mp="3jxmg5r6qn21n">
        <h2 id="offer-title" className="text-center font-display text-[30px] font-black leading-tight sm:text-[42px]" data-id="element-196" data-mp="3nvk4krsopk3z">
          Here's everything you're getting <em className="text-sky" data-id="element-197" data-mp="1pn8g4tzbd6g">today</em>
        </h2>

        <div className="mt-10 overflow-hidden rounded-3xl bg-white text-ink" data-id="element-198" data-mp="1q5e1s2j73r1">
          <img src={images.mockup} alt="The complete Safe Spine Method™ system" className="w-full bg-paper px-2 pt-4" data-id="element-199" data-mp="1kmjewzjm8t3h" />
          <div className="p-5 sm:p-8" data-id="element-200" data-mp="1fku1xecu25cr">
            <ul className="divide-y divide-line" data-id="element-201" data-mp="1bkifpx4tnwz6">
              {stack.map(({
              icon: Icon,
              label,
              value
            }) => <li key={label} className="flex items-center gap-3 py-4" data-id="element-202" data-mp="16m8ilgzjemax">
                  <Icon className="h-6 w-6 shrink-0 text-brand" aria-hidden="true" data-id="element-203" data-mp="23bybohs9qw22" />
                  <span className="flex-1 text-[16px] font-semibold leading-snug" data-id="element-204" data-mp="23e2awmf836w0">{label}</span>
                  <span className="shrink-0 font-bold text-muted line-through" data-id="element-205" data-mp="1zch3vhpddmtq">{value}</span>
                </li>)}
            </ul>
            <p className="mt-2 flex items-center justify-between rounded-xl bg-paper px-4 py-3 text-[16px] font-bold" data-id="element-206" data-mp="1plcqunj98c1j">
              Total value <span className="text-flame line-through" data-id="element-207" data-mp="2n1i6upffo5rm">$244</span>
            </p>

            <p className="mt-8 text-center text-sm font-bold uppercase tracking-wide text-muted" data-id="element-208" data-mp="2i8771891gp97">
              But today, the complete system is available for…
            </p>
            <p className="mt-2 text-center font-display text-[88px] font-black leading-none text-brand sm:text-[110px]" data-id="element-209" data-mp="3653gycxfyu1s">$27</p>
            <ul className="mt-5 grid grid-cols-2 gap-2" data-id="element-210" data-mp="2scduy8hwxp4o">
              {perks.map(p => <li key={p} className="rounded-lg bg-brand-light px-2 py-2 text-center text-[12px] font-extrabold uppercase leading-tight text-navy sm:text-[13px]" data-id="element-211" data-mp="2wdpfw0pudm6j">
                  {p}
                </li>)}
            </ul>

            <div className="mt-7" data-id="element-212" data-mp="2nbpukw7snvxs">
              <CtaButton label="Get the Safe Spine Method™" caption="Only $27 · Instant Access · Lifetime Access · 7-Day Guarantee" data-id="element-213" data-mp="29et44vvl8ghf" />
            </div>

            <div className="mt-8" data-id="element-214" data-mp="2dhz9806ys1mb">
              <Countdown data-id="element-215" data-mp="7n7r0s8fzrgi" />
            </div>

            <div className="mt-8" data-id="element-216" data-mp="7ng3wk4kewrp">
              <ScarcityBar data-id="element-217" data-mp="boji726yskqt" />
            </div>

            <p className="mt-6 flex items-start justify-center gap-2 text-center text-sm font-medium text-muted" data-id="element-218" data-mp="bni38mmtve3t">
              <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-219" data-mp="1w73qkg5okdx5" />
              Currency conversion is automatically handled according to your country.
            </p>
          </div>
        </div>

        <div className="mt-10 space-y-2 text-center text-[17px] text-white/80" data-id="element-220" data-mp="25ygh94fqsy1l">
          <p data-id="element-221" data-mp="214cc8qq1f035">You don't need another expensive certification.</p>
          <p data-id="element-222" data-mp="2ftrzhwqd0ne3">You don't need another 20-hour course.</p>
          <p data-id="element-223" data-mp="2fwe7tyl2r6xd">You don't need another massive textbook.</p>
          <p className="pt-2 text-xl font-bold text-white" data-id="element-224" data-mp="2auf60t4zgi2j">You need a practical system you can actually use.</p>
        </div>
      </div>
    </section>;
}